import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";

import thunkMiddleware from "redux-thunk";

import itemListsReducer from "shared/itemLists/redux/itemListsSlice";
import authReducer from "shared/auth/redux/authSlice";
import checklistReducer from "shared/checklists/redux/checklistSlice";
import waitForIdReducer from "shared/middleware/waitForId/waitForIdSlice";

import { combineReducers } from "redux";
import platformReducers from "glassRedux/platformReducers"

import waitForIdMiddleWare from "shared/middleware/waitForId/waitForIdMiddleware";
import reloadPlanMiddleware from "shared/middleware/reloadPlanMiddleware";
import alignScrollMiddleware from "shared/middleware/alignScrollMiddleware";

console.log('platformReducers in reduxStore: ', platformReducers);

const appReducer = combineReducers({
  itemLists: itemListsReducer,
  auth: authReducer,
  checklist: checklistReducer,
  waitForId: waitForIdReducer,
  ...platformReducers
});

const rootReducer = (state, action) => {
  if (action.type === "USER_LOGOUT") {
    state = undefined;
  }
  return appReducer(state, action);
};

const composeEnhancers = composeWithDevTools({
  trace: true,
});

export default function createGlassStore({
  middleware,
  enhanceReducer,
  enhanceStore,
}) {
  return createStore(
    enhanceReducer(rootReducer),
    {},
    composeEnhancers(
      enhanceStore,
      applyMiddleware(
        middleware,
        thunkMiddleware,
        waitForIdMiddleWare,
        reloadPlanMiddleware,
        alignScrollMiddleware
      )
    )
  );
}
